/**
 * Tailwind's default breakpoints in pixels.
 * Keep in sync with `tailwind.config.js` if the defaults are ever overridden.
 */
export const TAILWIND_BREAKPOINTS = {
    SM: 640,
    MD: 768,
    LG: 1024,
    XL: 1280,
    '2XL': 1536,
} as const
